import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Support from './pages/Support';
import News from './pages/News';
import Photos from './pages/Photos';
import Contact from './pages/Contact';
import CalendarPage from './pages/CalendarPage';
import Marketplace from './pages/Marketplace';
import Partners from './pages/Partners';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.css';
import {AuthProvider} from "./contexts/AuthContext";
import { ToastContainer } from 'react-toastify';

function App() {
  return (
      <AuthProvider>
          <Router>
            <div className="App">
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/calendar" element={<CalendarPage />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/photos" element={<Photos />} />
                  <Route path="/marketplace" element={<Marketplace />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Layout>
              <ToastContainer position="top-right" autoClose={3000} />
            </div>
          </Router>
    </AuthProvider>
  );
}

export default App;